import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
// import { environment } from '@environment';
import { ConfigService } from '../config.service';
import { Observable, Subject } from 'rxjs';
import { Utilities } from '../../_helpers/utility/utilities';
import { User } from '../../_models';
import { EndpointSettings } from '../../_models/endpoint-settings/endpoint-settings';
import { AuthenticationService } from './authentication/authentication.service';
// import { ConfigurationService } from './configuration.service';

// avoids circula dependency betwqeen auth service and endpoint factory service
@Injectable({
  providedIn: 'root'
})
export class LoginEndpointFactoryService {
  static readonly apiVersion: string = '1';

  private readonly _baseUrl = this.environment.userApi.baseUrl;
  private readonly _loginUrl = this._baseUrl + this.environment.userApi.login;

  private _username:string="";
  private _password:string="";


  private get loginUrl() {
    return this._loginUrl;
  }
  constructor(protected http: HttpClient, public injector: Injector, private environment: ConfigService) { }

  getLoginEndpoint(username: string, password: string): Observable<Response> {
    this._password=password;
    this._username=username;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Authorization: 'Basic ' + btoa(username + ':' + password)
      })
    };
    return this.http.get<Response>(`${this.loginUrl}`, httpOptions);

  }

}



@Injectable({
  providedIn: 'root'
})
export class EndpointFactoryService {
  static readonly apiVersion: string = '1';

  private readonly _baseUrl = this.environment.userApi.baseUrl;
  private readonly _loginUrl = this._baseUrl + this.environment.userApi.login;

  private get loginUrl() {
    return this._loginUrl;
  }

  private taskPauser: Subject<any>;
  private isRefreshingLogin: boolean;

  // protected configurations: ConfigurationService,
  constructor(private AuthenticationService: AuthenticationService, protected http: HttpClient, public injector: Injector, private environment: ConfigService) {

  }

  // private generateHttpOptions()
  // {

  //   var username = this.AuthenticationService.getUserName();
  //   var password = this.AuthenticationService.getUserPassword();

  //   const httpOptions = {
  //     headers: new HttpHeaders({
  //       'Content-Type': 'application/json',
  //       Authorization: 'Basic ' + btoa(username + ':' + password)
  //     })
  //   };

  //   return httpOptions;
  // }

  get(finalUrl: string, endpointSettings: EndpointSettings = { updateLocalUser: false } as EndpointSettings, options?: any) {
   // var httpOptions = this.generateHttpOptions();
    return this.http.get<Response>(finalUrl, Utilities.showNotificationHeader(true)).subscribe((response) => {      
      // this.updateUserFromResonse(response, endpointSettings);
    });
  }

  post(finalUrl: string, endpointSettings: EndpointSettings = { updateLocalUser: false } as EndpointSettings) {
  //  var httpOptions = this.generateHttpOptions();
    return this.http.post<Response>(finalUrl,{}).subscribe((response) => {
      this.updateUserFromResonse(response, endpointSettings);
    });

  }

  // only updates user object if response is a valid user object and if it is requested in the EndPointSettings object
  private updateUserFromResonse(response: Response, endpointSettings: EndpointSettings) {

    if (endpointSettings && endpointSettings.updateLocalUser) {

      if (this.checkIfResponseIsValidUserJSON(response)) {

        var currUser = this.AuthenticationService.currentUser;
        let user = new User(response as any); //TODO: 
        // user.authdata=currUser.authdata;//Critical:This makes sure we keep the users auth data from when they logged in
        this.AuthenticationService.currentUser = user;
      }
    }
  }

  private checkIfResponseIsValidUserJSON(response: any) {
    const user = new User(response);
    return (user.userId != null && user.username != null);
  }

  // *******************   API   *******************************//



  setIsSelfCertifiedApprover(isCertified: boolean, userId:number) {
    const currUser = this.AuthenticationService.currentUser;
    const endptSettings = new EndpointSettings(currUser.userId === userId);
    //TODO:discuss if we should make a general url generator so we dont duplicate this 500 times
    const finalUrl = this._baseUrl + '/' + userId + this.environment.userApi.isCertifiedApprover + `?value=${isCertified}`;

    return this.get(finalUrl, endptSettings, Utilities.showNotificationHeader(true));
  }





  // ************************************************************* //


  // getLoginEndpoint(userName: string, password: string): Observable<Response> {
  // 	let header = new Headers();
  // 	header.append('Content-Type', 'application/x-www-form-urlencoded');
  // 	let searchParams = new URLSearchParams();
  // 	searchParams.append('username', userName);
  // 	searchParams.append('password', password);
  // 	searchParams.append('grant_type', 'password');
  // 	searchParams.append('scope', 'openid email phone profile offline_access role');
  // 	searchParams.append('resource', window.location.origin);
  // 	let requestBody = searchParams.toString();
  // 	return this.http.post(this.loginUrl, requestBody, { headers: header });
  // }
  // getRefreshLoginEndpoint(): Observable<Response> {
  // 	let header = new Headers();
  // 	header.append('Content-Type', 'application/x-www-form-urlencoded');
  // 	let searchParams = new URLSearchParams();
  // 	searchParams.append('refresh_token', this.authServiceTest.refreshToken);
  // 	searchParams.append('grant_type', 'refresh_token');
  // 	searchParams.append('scope', 'openid email phone profile offline_access role');
  // 	let requestBody = searchParams.toString();
  // 	return this.http
  // 		.post(this.loginUrl, requestBody, { headers: header })
  // 		.map((response: Response) => {
  // 			return response;
  // 		})
  // 		.catch(error => {
  // 			return this.handleError(error, () => this.getRefreshLoginEndpoint());
  // 		});
  // }
  // protected getAuthHeader(includeJsonContentType?: boolean): RequestOptions {
  // 	let headers = new Headers({ Authorization: 'Bearer ' + this.authServiceTest.accessToken });
  // 	if (includeJsonContentType) headers.append('Content-Type', 'application/json');
  // 	headers.append('Accept', `application/vnd.iman.v${EndpointFactory.apiVersion}+json, application/json, text/plain, */*`);
  // 	headers.append('App-Version', ConfigurationService.appVersion);
  // 	return new RequestOptions({ headers: headers });
  // }
  // public handleError(error, continuation: () => Observable<any>) {
  // 	if (error.status == 401) {
  // 		if (this.isRefreshingLogin) {
  // 			return this.pauseTask(continuation);
  // 		}
  // 		this.isRefreshingLogin = true;
  // 		return this.authServiceTest
  // 			.refreshLogin()
  // 			.mergeMap(data => {
  // 				this.isRefreshingLogin = false;
  // 				this.resumeTasks(true);
  // 				return continuation();
  // 			})
  // 			.catch(refreshLoginError => {
  // 				this.isRefreshingLogin = false;
  // 				this.resumeTasks(false);
  // 				if (refreshLoginError.status == 401 || (refreshLoginError.url && refreshLoginError.url.toLowerCase().includes(this.loginUrl.toLowerCase()))) {
  // 					this.authServiceTest.reLogin();
  // 					return Observable.throw('session expired');
  // 				} else {
  // 					return Observable.throw(refreshLoginError || 'server error');
  // 				}
  // 			});
  // 	}
  // 	if (error.url && error.url.toLowerCase().includes(this.loginUrl.toLowerCase())) {
  // 		this.authServiceTest.reLogin();
  // 		return Observable.throw('session expired');
  // 	} else {
  // 		return Observable.throw(error || 'server error');
  // 	}
  // }
  // private pauseTask(continuation: () => Observable<any>) {
  // 	if (!this.taskPauser) this.taskPauser = new Subject();
  // 	return this.taskPauser.switchMap(continueOp => {
  // 		return continueOp ? continuation() : Observable.throw('session expired');
  // 	});
  // }
  // private resumeTasks(continueOp: boolean) {
  // 	setTimeout(() => {
  // 		if (this.taskPauser) {
  // 			this.taskPauser.next(continueOp);
  // 			this.taskPauser.complete();
  // 			this.taskPauser = null;
  // 		}
  // 	});
  // }
}
